import { Component, Input } from '@angular/core';
import { OrderDetailDTO } from '@soctrip/angular-order-service';
import { MessageService } from 'primeng/api';
import { SoctripIcons } from 'src/app/core/constants/soctrip-icon.enum';
import { OrderType } from 'src/app/core/enum/order.enum';
import { CustomTranslateService } from 'src/app/core/services/custom-translate.service';
import { FileService } from 'src/app/core/services/file.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent {
  @Input() order: OrderDetailDTO;

  readonly SoctripIcons = SoctripIcons;
  readonly orderType = OrderType;
  orderPrefix = 'section-order-management.';

  constructor(
    private fileService: FileService,
    private messageService: MessageService,
    private translator: CustomTranslateService,
  ) {}

  getTotalProduct(quantity: number, price: number) {
    return price * quantity;
  }
  getImgWebp(id: string) {
    return this.fileService.getImgWebp(id);
  }

  getCurrencyCode(): string {
    return this.order?.payment?.origin_currency ?? 'USD';
  }

  getOriginRate(): number {
    return this.order?.payment?.origin_rate ?? 0;
  }

  formatPrice(price?: number): number {
    if (price == null) return 0;
    const code = this.getCurrencyCode();
    const rate = this.getOriginRate();
    return code === 'VND' && rate ? price / rate : price;
  }

  onCopySuccess() {
    this.messageService.add({
      severity: 'success',
      detail: this.translator.sentenceCase(
        `${this.orderPrefix}copied-successfully`,
      ),
    });
  }
}
